module.exports = __webpack_public_path__ + "static/media/tanmay-shree.e1d1062f.jpg";